import request from '@/utils/request'
import serve from '@/utils/request.js'
import Setting from '@/settings.js'
var { dicDomain} = Setting
// //用户登陆
// export function login () {
//   return request.post("https://www.fastmock.site/mock/bcf657033289ec6576c5207b8584fc26/jingdong/vue-admin-template/user/login", { 'data': 'data' })
// }
//获取用户信息
export function getInfo () {
  return request.get("https://www.fastmock.site/mock/bcf657033289ec6576c5207b8584fc26/jingdong/vue-admin-template/user/login", { 'data': 'data' })
}

export function logout () {
  // return request({
  //   url: '/vue-admin-template/user/logout',
  //   method: 'post'
  // })
  return request.get(dicDomain+"/base/admin/enter/logout")
}
//登录接口
export function login (data) {
  return serve.post(dicDomain + "/base/admin/enter/login", data)
}
